import { BotPartSlot, CompletePartDataSet } from '@nova/types';

/** Shallow copy per slot — e.g. lobby `player.parts` must not alias `novaUser.gameplayData.equippedParts` when debug mutates slots. */
export function cloneCompletePartDataSet(parts: CompletePartDataSet): CompletePartDataSet {
  const out = {} as CompletePartDataSet;
  for (const slot of Object.values(BotPartSlot)) {
    out[slot] = { ...parts[slot] };
  }
  return out;
}
